export default (process?.env?.VUE_APP_FREE_VERSION) === 'true'
